import { Component, Input, AfterViewInit, Inject, signal } from '@angular/core';
import { LoggerService } from '@wdpr/ra-angular-logger';

import { CalendarService } from '@finder/shared/services/calendar-service/calendar-service.service';
import { ScheduleDetail } from './schedule-info.interface';
import { LOCALE_NORMALIZED_DEFAULT } from '@finder/shared/constants/app.constants';
import {
    GetSimpleDateFromDateObjectProvider,
    GET_SIMPLE_DATE_FROM_DATE_OBJECT
} from '@finder/shared/utils/date/getSimpleDateFromDateObject';
import { asapScheduler } from 'rxjs';
import { CommonModule } from '@angular/common';
import { CalendarComponent } from '@finder/shared/components/calendar/calendar.component';
import { LinkIdDirective } from '@finder/shared/directives/link-id/link-id.directive';
import { LocaleDirective } from '@finder/shared/directives/locale/locale.directive';
import { FormatTimePipe } from '@finder/shared/utils/pipes/format-time/format-time.pipe';
import { ScheduleTypePipe } from '@finder/shared/utils/pipes/schedule-type/schedule-type.pipe';

const locale = LOCALE_NORMALIZED_DEFAULT;
export type numericDate = '2-digit' | 'numeric';
export type longDate = 'long';


@Component({
    selector: 'finder-schedule-info',
    templateUrl: './schedule-info.component.html',
    styleUrls: ['./schedule-info.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        CalendarComponent,
        LinkIdDirective,
        LocaleDirective,
        FormatTimePipe,
        ScheduleTypePipe,
    ]
})
export class ScheduleInfoComponent implements AfterViewInit {
    @Input() scheduleData: any;
    @Input() locationData: any;
    @Input() scheduleOpen: boolean;
    schedules: ScheduleDetail[] = [];
    date: Date = new Date();
    selectedDay  = '';
    schedules$$ = signal<ScheduleDetail[]>([]);

    constructor(
        public calendarService: CalendarService,
        private logger: LoggerService,
        @Inject(GET_SIMPLE_DATE_FROM_DATE_OBJECT) private getSimpleDateFromDateObject: GetSimpleDateFromDateObjectProvider,
    ) {}

    ngAfterViewInit() {
        if (!this.scheduleData) {
            this.logger.error(`Error - invalid schedule data!`);

            return;
        }
        this.getScheduleDetails(this.date);
    }

    parseTime(time) {
        const options = {
            hour: '2-digit' as numericDate,
            minute: '2-digit' as numericDate,
            hour12: true,
            timeZone: 'UTC'
        };

        return new Date(time).toLocaleDateString(locale, options);
    }

    onDateSelected(event) {
        // Get selected schedule details
        this.getScheduleDetails(event);
    }

    private getScheduleDetails(date) {
        const jsDate = new Date(Date.parse(date));

        // Get date in YYYY-MM-DD format
        const formattedDate = this.getSimpleDateFromDateObject(jsDate, locale);

        // Find the matching schedule - we should not even be here if there are no schedules
        // so we don't have to worry about checking for data.
        this.schedules = (this.scheduleData.schedules || []).filter(schedule =>
            schedule.date === formattedDate
        );

        this.schedules$$.set(this.schedules);

        // Format the selected day for the UI
        const options = {
            weekday: 'long' as longDate,
            year: 'numeric' as numericDate,
            month: 'long' as longDate,
            day: 'numeric' as numericDate
        };

        // Give the template time to settle
        asapScheduler.schedule(() => {
            this.selectedDay = jsDate.toLocaleDateString(locale, options);
        });
    }
}
